/**
 * Counts the server reads still waiting for an answer, outside Redux. Reads start
 * and finish dozens of times a minute while an operator scrolls a grid; putting that
 * churn in the store would redraw every screen that watches the connection. The one
 * consumer — the badge deciding when a reconnection has finished catching up — only
 * needs to know when the count reaches zero, so that is all this exposes.
 */
let pendingReads = 0;
const idleListeners = new Set();

/** How many reads are still waiting for the server. */
export const pendingReadCount = () => pendingReads;

/** A read went out; the screens are not caught up until it is answered. */
export const readStarted = () => {
    pendingReads += 1;
};

/** A read was answered. When nothing is left waiting, whoever asked is told once. */
export const readFinished = () => {
    if (pendingReads === 0) return;
    pendingReads -= 1;
    if (pendingReads === 0) idleListeners.forEach((listener) => listener());
};

/** The link dropped: answers to the reads in flight are not coming, so stop waiting for them. */
export const resetPendingReads = () => {
    pendingReads = 0;
};

/** Be told the next time(s) no read is waiting. Returns the function that stops listening. */
export const onReadsIdle = (listener) => {
    idleListeners.add(listener);
    return () => idleListeners.delete(listener);
};
